<script>
  import Editor from './Editor.svelte';
  import Container from './Container.svelte';

  export let addTask;

  let targetSignature = `class Counter:
    def __init__(self, initial_value=0):
        # Initiates the Counter with self.value = initial_value
        self.value = None  # Counter's value shoud be set here
        ...
    def increment(self, amount=1):
        # Increments self.value by 'amount' and returns self
        ...
`

  let visibleTest = `assert Counter(10).value == 10

assert Counter().increment(1).value == 1

assert Counter().increment(1).increment(30).value == 31
`

  let hiddenTest = `assert Counter(3).increment(-1).value == 2

assert Counter().increment().increment().value == 2
`
  let price = "2.00";
  let maxDevTime = "3";

</script>

<Container>
  <h1>Create New Task</h1>

  <h2>Target Signature</h2>
  <Editor bind:text={targetSignature} language="python"/>

  <!-- <div>
    <h3>Task Type</h3>
    <input type="radio" id="PassFail" name="taskType" value="PassFail">
    <label for="PassFail">Pass/Fail</label><br>

    <input type="radio" id="Performance" name="taskType" value="Performance">
    <label for="Performance">Performance Metric</label><br>
  </div> -->
  <h2>Visible Test</h2>
  <Editor bind:text={visibleTest} language="python"/>

  <h2>Hidden Test</h2>
  <Editor bind:text={hiddenTest} language="python"/>

  <h2>Price (USD)</h2>
  <input style="text-align: center" bind:value={price}/>

  <h2>Max Development Time (min)</h2>
  <input style="text-align: center" bind:value={maxDevTime}/>

  <div style="margin: 100px"/>

  <div>
    <a href='/client' class='pure-button'>Cancel</a>
    <a href='/client' class='pure-button pure-button-primary' style='background-color: var(--primary-color);'
      on:click={async () => await addTask(targetSignature, visibleTest, hiddenTest, price, maxDevTime)}>Create Task</a>
  </div>
</Container>

<style>
  h1, h2 {
    font-weight: 100;
  }
  input {
    text-align: center;
    border-style: none;
    border-bottom-style: solid;
  }
</style>